import { useStaticQuery, graphql } from "gatsby"

export default function KinshipData() {
	const query = graphql`
		query ClanKinshipData {
			allCclansKinshipCsv(filter: {latitude: {ne: ""}}) {
				nodes {
					ccchi
					cceng
					cchypy
					id
					yearest
					address
					phone
					member
					kinship
					latitude
					longitude
					website
				}
			}
		}
	`

	const { allCclansKinshipCsv } = useStaticQuery(query) || {}

	return allCclansKinshipCsv?.nodes
					.map(node => ({
						...node,
						longitude: parseFloat(node.longitude),
						latitude: parseFloat(node.latitude),
						type: "K",
					}))
}
